<!--<head>-->
<!--  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />-->
<!--</head>-->
<template>
  <div id="vue">
    <div id="head1">
      <div class="logo"><img src="../assets/img/logo.jpg" alt=""></div>
      <div class="head_right">
        <div style="font-size: 22px">
          <span class="mxname" style="margin-right: 100px">MxCADOnline</span>
          <span class="filename">file.dwg</span>
          sss
        </div>
        <div id="tab" style="border-color: #2c3e50;width: 100%;height: 20px">
          <template>

            <el-tabs v-model="activeName" @tab-click="handleClick">

              <el-tab-pane label="常用" name="t1" class="is-active">常用</el-tab-pane>

              <el-tab-pane label="插入" name="t2">插入</el-tab-pane>

              <el-tab-pane label="注释" name="t3">注释</el-tab-pane>

              <el-tab-pane label="参数化" name="t4">参数化</el-tab-pane>

              <el-tab-pane label="视图" name="t5">视图</el-tab-pane>

              <el-tab-pane label="管理" name="t6">管理</el-tab-pane>

              <el-tab-pane label="输出" name="t7">输出</el-tab-pane>

              <el-tab-pane label="插件" name="t8">插件</el-tab-pane>

              <el-tab-pane label="联机" name="t9">联机</el-tab-pane>

              <el-tab-pane label="Express Tools" name="t10">Express Tools</el-tab-pane>

              <!--            <el-tab-pane label="" name="t11"></el-tab-pane>-->

            </el-tabs>

          </template>
        </div>

      </div>
    </div>
    <div id="head2">
      {{message}}
      <el-button type="success" icon="el-icon-success" size="small" @click="show3">
      按钮测试
      </el-button>
    </div>
    <div id="content">
      <template>
        <el-row>
          <el-col :span="6" class="title">
            <b><i class="el-icon-eleme" /> Element图标应用</b>
          </el-col>
          <el-col :span="6">
            <el-link icon="el-icon-s-home" type="primary">主页</el-link>&nbsp;
            <el-link>
              <i class="el-icon-user-solid"></i> 个人设置
            </el-link>
          </el-col>
          <el-col :span="6">
            <el-input suffix-icon="el-icon-search" size="mini"/>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-button icon="el-icon-upload" type="primary" size="mini">登录</el-button>
            <el-button size="mini">
              <i class="el-icon-edit"></i> 注册
            </el-button>
          </el-col>
        </el-row>
      </template>
    </div>
    <div id="footer"></div>


  </div>

</template>

<script>
    export default {
        name: "myVue",

        data (){ //注意：data即使不需要传数据，也必须return,否则会报错

            return {
                message: "这是一个测试",
                msg2:'111111111',
                show3:'111',
                activeName: 't1'
            }
        },
        watch:{
              'activeName':function (val) {
                  //这里执行点击切换tab后的方法
                  //alert(val)
              }
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
                if(tab.name == 't1'){
                    // 触发‘配置管理’事件
                    this.t1();
                }else{
                    // 触发‘用户管理’事件
                    this.t2();
                }
            },
            /**
             * 触发‘用户管理’事件
             */
            t1(){
                console.log('t1');
            },
            /**
             * 触发‘配置管理’事件
             */
            t2(){
                console.log('t2');
            }
        }
    }
</script>

<style>
  @import "../assets/css/ele.css";
</style>
<style scoped>
  #vue{
    color: green;
    font-size: 28px;
    width: 100%;
    height: 1280px;
    /*border: 1px solid red;*/
  }

  #head1{
    /*background-color: #42b983;*/
    height: 5%;
  }
  #head2{
    background-color: #d7d7d7;
    height: 10%;
  }
  #content{
    background-color: #8c8c8c;
    height: 70%;
  }
  #footer{
    background-color: #d7d7d7;
    height: 15%;
  }
  .logo{
    /*border: red 1px solid;*/
    width: 60px;
    height: 60px;
    float: left;
  }
  .logo img{
    width: 60px;
    height: 60px;

  }
  .head_right{
    width: 90%;
    height: 60px;
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/myVue.vue